import React from "react";
import Input from "@insightfulscience/atomic-react/Input";
import { acceptKeys, DIGITS } from "@insightfulscience/smart-react/events/acceptKeys";

const acceptDigitsOnly = acceptKeys(DIGITS);

const SeatsInput = props => (
	<Input {...props} type="number" hideInputNumberArrows={false} onKeyPress={acceptDigitsOnly} />
);

export default SeatsInput;
